// extracted by mini-css-extract-plugin
module.exports = {"checkBoxItem":"Checkbox_checkBoxItem__Gczw2","checkBox":"Checkbox_checkBox__HLl1a","checkMark":"Checkbox_checkMark__vnicV"};